import { render, staticRenderFns } from "./ConsentLists.vue?vue&type=template&id=5c01974b&"
import script from "./ConsentLists.vue?vue&type=script&lang=js&"
export * from "./ConsentLists.vue?vue&type=script&lang=js&"
import style0 from "./ConsentLists.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports